import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const CollapseHeader = styled(Box)({
  backgroundColor: "#eff2f6"
});

export const CollapseText = styled(Typography)({
  cursor: "pointer",
  display: "inline"
}); 